import { TableHeader } from "@/models/TableHeader";

export const unitManagementHeaders: TableHeader[] = [
  {
    text: "Unit Type",
    value: "type_name"
  },
  {
    text: "Width",
    value: "width"
  },
  {
    text: "Length",
    value: "length"
  },
  {
    text: "Rate",
    value: "rate"
  },
  {
    text: "Floor",
    value: "floor"
  },
  {
    text: "Alarm",
    value: "alarm"
  },
  {
    text: "Power",
    value: "power"
  },
  {
    text: "Inside",
    value: "inside"
  },
  {
    text: "Mobile",
    value: "mobile"
  },
  {
    text: "Climate",
    value: "climate"
  },
  {
    text: "Promotion",
    value: "promotion_text"
  }
];
